// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PlatformHeader{height:100%;width:100%}.PlatformHeader a:link{display:inline-flex;height:100%}.PlatformHeader img{box-sizing:border-box;cursor:pointer;height:38px;margin-top:4px;-o-object-fit:contain;object-fit:contain;-o-object-position:0 50%;object-position:0 50%;position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
